const API_URL = process.env.REACT_APP_API_URL;

// Get all main images (for admin)
export const getAllMainImages = async () => {
  try {
    const response = await fetch(`${API_URL}/api/commitment-main-images`);
    const data = await response.json();
    
    if (!response.ok) {
      throw new Error(data.message || 'Failed to fetch main images');
    }
    
    return data.data;
  } catch (error) {
    throw error;
  }
};

// Get active main images (for frontend)
export const getActiveMainImages = async () => {
  try {
    const response = await fetch(`${API_URL}/api/commitment-main-images/active`);
    const data = await response.json();
    
    if (!response.ok) {
      throw new Error(data.message || 'Failed to fetch active main images');
    }
    
    return data.data;
  } catch (error) {
    throw error;
  }
};

// Get single main image by ID
export const getMainImageById = async (id) => {
  try {
    const response = await fetch(`${API_URL}/api/commitment-main-images/${id}`);
    const data = await response.json();
    
    if (!response.ok) {
      throw new Error(data.message || 'Failed to fetch main image');
    }
    
    return data.data;
  } catch (error) {
    throw error;
  }
};

// Create new main image
export const createMainImage = async (imageData) => {
  try {
    const response = await fetch(`${API_URL}/api/commitment-main-images`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(imageData),
    });
    
    const data = await response.json();
    
    if (!response.ok) {
      throw new Error(data.message || 'Failed to create main image');
    }
    
    return data.data;
  } catch (error) {
    throw error;
  }
};

// Update main image
export const updateMainImage = async (id, imageData) => {
  try {
    const response = await fetch(`${API_URL}/api/commitment-main-images/${id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(imageData),
    });
    
    const data = await response.json();
    
    if (!response.ok) {
      throw new Error(data.message || 'Failed to update main image');
    }
    
    return data.data;
  } catch (error) {
    throw error;
  }
};

// Toggle main image active status
export const toggleMainImageActive = async (id) => {
  try {
    const response = await fetch(`${API_URL}/api/commitment-main-images/${id}/toggle-active`, {
      method: 'PATCH',
    });
    
    const data = await response.json();
    
    if (!response.ok) {
      throw new Error(data.message || 'Failed to toggle main image active status');
    }
    
    return data.data;
  } catch (error) {
    throw error;
  }
};

// Delete main image
export const deleteMainImage = async (id) => {
  try {
    const response = await fetch(`${API_URL}/api/commitment-main-images/${id}`, {
      method: 'DELETE',
    });
    
    const data = await response.json();
    
    if (!response.ok) {
      throw new Error(data.message || 'Failed to delete main image');
    }
    
    return data.data;
  } catch (error) {
    throw error;
  }
};